$(document).ready(function(){

  
  //SLIDE SHARE MENU
var a = $('.menutab')
var b = $('.fixedheader')  
var c = $('.dropmenu')  
var d = $('.menutab img')
var e = $('.sdwn')
a.click(function(){
  
if (a.hasClass('ON'))
{a.removeClass('ON');
TweenMax.allTo([a,c,b],.5, {top:"-=80px",ease:Expo.easeOut});
TweenMax.to(e,.5, {marginTop:"-=80px",ease:Expo.easeOut});  
TweenMax.to(d, .5, {rotation:0});
}else{
a.addClass('ON');
TweenMax.allTo([a,c,b],.5, {top:"+=80px",ease:Expo.easeOut});
TweenMax.to(e,.5, {marginTop:"+=80px",ease:Expo.easeOut});  
TweenMax.to(d, .5, {rotation:45});
}  
});

  

  
///////*videopanel*///////
$('.fullvid span').videobackground({
  videoSource: [['http://vimeo.com/87580782/download?t=1393373660&v=230494907&s=be3f1f8bf8010c3e8f923fe6df154ed3', 'video/mp4']],

loop:true,
resize:false,
autoplay:true,
preload:true,

loadedCallback: function() {
  
$(this).videobackground('mute');
var wr = $(window).width() / $(window).height();
var vr = $('.fullvid video').width() / $('.fullvid video').height();
if(wr > vr){
$('.fullvid video').css('width','100%');
$('.fullvid video').css('height','auto');
}else{
$('.fullvid video').css('width','auto');
$('.fullvid video').css('height','100%');
} 
}  
});
  
  /*resize video*/
  $(window).resize(function(){  
var wr = $(window).width() / $(window).height();
var vr = $('.fullvid video').width() / $('.fullvid video').height();
if(wr > vr){
$('.fullvid video').css('width','100%');
$('.fullvid video').css('height','auto');
}else{
$('.fullvid video').css('width','auto');
$('.fullvid video').css('height','100%');
} 
  });
  
  ///SORT
  
  
  

  
  /*sort functions*/
  
    $('.sortup').click(function(){
  // get href attribute, minus the '#'
  var sortName = $(this).attr('href').slice(1);
  $('#mngrd').isotope({ sortBy : sortName ,sortAscending : true});
       $('.tlerw a').removeClass('active');
     $(this).addClass('active');
  return false;
});
   
   
      $('.sortdown').click(function(){
  // get href attribute, minus the '#'
  var sortName = $(this).attr('href').slice(1);
  $('#mngrd').isotope({ sortBy : sortName ,sortAscending : false});
      $('.tlerw a').removeClass('active');
     $(this).addClass('active');
  return false;
});
  
  $('#filters a').click(function(){
    
    var fder = $(this).text()
    
    if(fder == "Store")
    {
    $('.allstore').addClass('active');
    $('#sndblg').hide();
    $('#sndfwrp').fadeIn();
    
    }
    
    else if(fder == "Blog") {
    $('.allstore').addClass('active');
    $('#sndfwrp').hide();
    $('#sndblg').fadeIn()
    }else{  
    $('.sndfwrp').fadeOut();
    $('.sndfwrp a').removeClass('active');
    $('.allstore').addClass('active');
     }
    
  
    
  var selector = $(this).attr('data-filter');
$('#mngrd').isotope({ filter: selector });
      $('#filters a').removeClass('active');
     $(this).addClass('active');
  return false;
});
   
  
  $('.sndfwrp a').click(function(){
  var selector = $(this).attr('data-filter');
 $('#mngrd').isotope({ filter: selector });
      $('.sndfwrp a').removeClass('active');
     $(this).addClass('active');
  return false;
});


   
  
  
  //isotope
  
  var $container = $('#mngrd');
 $container.imagesLoaded( function() {
     
      
 

// initialize isotope
$container.isotope({
itemSelector : '.item',
layoutMode : 'masonry',
  
  
animationOptions: {
     duration: 750,
     easing: 'linear',
     queue: false
   },
  
  
 
 

});
   
   

     
  });
  
    
  
  });//ready
     
     